import PaymentContainerClient from "../../PaymentContainerClient";

export const setPaymentRequestAsPaid = async (
    token: string,
    note?: string
): Promise<void> => {
    const paymentContainerClient = new PaymentContainerClient();
    await paymentContainerClient.setPaymentRequestAsPaid(token, note);
};
